export var updateOverflowShadows = function (wrapper, table, rightShadow, leftShadow) {
    // Right shadow
    if (table && wrapper) {
        if (rightShadow) {
            var diff = table.offsetWidth - wrapper.offsetWidth;
            rightShadow.style.display =
                diff > 0 && diff > wrapper.scrollLeft ? 'block' : 'none';
        }
        if (leftShadow) {
            leftShadow.style.display = wrapper.scrollLeft > 0 ? 'block' : 'none';
        }
    }
    return;
};
//# sourceMappingURL=update-overflow-shadows.js.map